// src/config.js

let runtimeURL = "";

// Read value from public/config.js
if (typeof window !== "undefined" && window.APP_CONFIG?.API_URL) {
  runtimeURL = window.APP_CONFIG.API_URL;
}

const CONFIG = {
  API_URL: runtimeURL
};

export default CONFIG;
